import { Text, styled } from '@volkswagen-onehub/components-core';
import React, { useState } from 'react';
import {
	TextWrapper,
	Wrapper,
} from 'src/feature-app/NewMap/components/CommonStyledComponents';
import {
	MarkerDimensions,
	useMapGeneralController,
} from 'src/feature-app/NewMap/MapGeneralController';
import { COLOR_TOKEN } from 'src/components/color-token';

const MarkerSvgContainer = styled.div<{ markerDimensions: MarkerDimensions }>`
	width: ${props => `${props.markerDimensions.width}px`};
	height: ${props => `${props.markerDimensions.height}px`};
	& svg {
		width: 100%;
		height: 100%;
	}
`;
import { Points } from 'src/types';

interface ClusterMarkerProps {
	lat: number;
	lng: number;
	pointCount: number;
	onClick: any;
	isHover: boolean;
}

export const sameClusterId = (selectedPoint: Points, point: Points) => {
	if (selectedPoint?.properties?.parent_cluster_id && point.id) {
		return selectedPoint.properties.parent_cluster_id === point.id;
	}
	return false;
};

/* eslint-disable react/display-name */
export const ClusterMarker = React.memo(
	({ onClick, pointCount, isHover }: ClusterMarkerProps) => {
		const { markerDimensions } = useMapGeneralController();
		const [mouseEntered, setMouseEntered] = useState(false);

		return (
			<Wrapper
				onClick={e => {
					e.preventDefault();
					onClick();
				}}
				onMouseEnter={e => {
					e.preventDefault();
					setMouseEntered(true);
				}}
				onMouseLeave={e => {
					e.preventDefault();
					setMouseEntered(false);
				}}
			>
				<MarkerSvgContainer markerDimensions={markerDimensions}>
					<svg
						className="marker"
						fill={isHover || mouseEntered ? COLOR_TOKEN.main.button.tertiary.hover : COLOR_TOKEN.main.button.tertiary.default}
						viewBox="0 0 80 110"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path d="M40 110C40 110 80 65.0635 80 40.7095C80 16.3554 64.127 0 40 0C15.873 0 0 16.3554 0 40.7095C0 65.0635 40 110 40 110Z" />
					</svg>
				</MarkerSvgContainer>
				<TextWrapper>
					<Text staticSize>{pointCount}</Text>
				</TextWrapper>
			</Wrapper>
		);
	},
);
